/**
 *
 * WARNING : fichier généré par cli, ne pas le modifier directement
 *
 */
import * as R from 'ramda';
import { useQuery } from '@apollo/client';
import GetSouscriptionCustomerGranteesCountriesQuery from '../graphql/queries/GetSouscriptionCustomerGranteesCountriesQuery.js';

const useGetSouscriptionCustomerGranteesCountriesQuery = (args) => {
  const { data, error, loading, refetch } = useQuery(GetSouscriptionCustomerGranteesCountriesQuery, args);

  return {
    error,
    loading,
    refetch,
    getSouscriptionCustomerGranteesCountries: R.omit(['__typename'], data?.getSouscriptionCustomerGranteesCountries_souscription_customer_grantees || {})
  };
};

export default useGetSouscriptionCustomerGranteesCountriesQuery;
